import { action, computed, thunk } from 'easy-peasy';

import TEXT_ZJC from '../components/ModalPortal/graphql/textZjcLink';

const SEE_MORE_KEY = 'zeta_see_more_prompt';

const modalDisplayModel = {
  modalOpen: null,
  showZjc: false,

  setShowZjc: action((state, payload) => {
    state.showZjc = payload;
  }),

  openModal: action((state, payload) => {
    state.modalOpen = payload ? payload : 'get-started';
  }),

  closeModal: action((state, payload) => {
    state.modalOpen = null;
  }),

  setSeenMore: action((state, payload) => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(SEE_MORE_KEY, 'true');
    } else {
      return true;
    }
  }),

  hasSeenMore: computed(state => {
    if (typeof window !== 'undefined') {
      const val = window.localStorage.getItem(SEE_MORE_KEY);
      return val === 'true';
    } else {
      return false;
    }
  }),

  sendZjcText: thunk(async (action, payload, { injections }) => {
    const { client } = injections;

    const response = await client.mutate({
      mutation: TEXT_ZJC,
      variables: { input: { ...payload.variables } }
    });

    if (response?.data?.textZjcLink.errors.length === 0) {
      payload.callback && payload.callback();
    } else {
      payload.onError && payload.onError(response.data.textZjcLink.errors);
    }
  })
};

export default modalDisplayModel;
